// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2UGhi","search":"Settings_search__vrWo9","filter":"Settings_filter__3-6Bp"};